/* eslint-disable arrow-parens */
import {
  ACTIONS,
  ALEX_STATES,
  SCREENS,
  QUESTIONS_PER_LEVEL,
  GAME_ID,
  TOTAL_LEVELS,
} from '../dataManagement/Constants';
import { shuffleArray } from '../../../lib/utilityFunctions';

export const initialState = {
  screen: SCREENS.PROGRESS,
  interactionLocked: false,
  gameProgress: {
    lastLevelUnlocked: 0,
    firstTimePlayer: true,
  },
  currentRound: {
    alexState: ALEX_STATES.ACTIVE,
    levelIndex: 0,
    questionIndex: 0,
    level: 1,
    questionsAnswered: 0,
    itemTriesCount: 0,
    questionsCorrect: 0,
    percentComplete: 0,
    isRoundComplete: false,
    usedHint: false,
    rePlayOnBoarding: false,
  },
};

export const currentRound = (state = {}, action, levels) => {
  const { payload } = action;
  switch (action.type) {
    case ACTIONS.CHANGE_ALEX_STATE:
      return {
        ...state,
        alexState: payload,
      };

    case ACTIONS.START_NEW_ROUND:
      return {
        alexState: ALEX_STATES.ACTIVE,
        questionIndex: 0,
        questionsAnswered: 0,
        itemTriesCount: 0,
        questionsCorrect: 0,
        isRoundComplete: false,
        usedHint: false,
        levelIndex: payload.levelIndex,
        level: payload.levelIndex + 1,
        rePlayOnBoarding: payload.playOnBoarding,
        currentContent: helperFunctions.makeContentWithShuffledSet(
          levels,
          payload.levelIndex,
          0,
        ),
        percentComplete: 0,
      };

    case ACTIONS.LOAD_SERVER_DATA:
      return {
        ...state,
        ...payload,
      };

    case ACTIONS.ADVANCE_QUESTION:
      if (state.questionIndex + 1 < QUESTIONS_PER_LEVEL) {
        return {
          ...state,
          itemTriesCount: 0,
          usedHint: false,
          questionsAnswered: state.questionsAnswered + 1,
          questionIndex: state.questionIndex + 1,
          currentContent: helperFunctions.makeContentWithShuffledSet(
            levels,
            state.levelIndex,
            state.questionIndex + 1,
          ),
        };
      }
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
        isRoundComplete: true,
      };

    case ACTIONS.INCREASE_INCORRECT_ANSWER_COUNT:
      return {
        ...state,
        itemTriesCount: state.itemTriesCount + 1,
        usedHint: true,
      };

    case ACTIONS.INCREASE_CORRECT_ANSWER_COUNT:
      return {
        ...state,
        questionsCorrect: state.questionsCorrect + 1,
      };

    case ACTIONS.ADVANCE_PROGRESS_POINTER:
      return {
        ...state,
        percentComplete: (state.questionIndex + 1) * 100 / QUESTIONS_PER_LEVEL,
      };

    default:
      return state;
  }
};

export const gameProgress = (state = initialState.gameProgress, { type, payload }) => {
  switch (type) {
    case ACTIONS.MARK_ONBOARDING_AS_COMPLETE:
      return {
        ...state,
        firstTimePlayer: false,
      };

    case ACTIONS.TRY_UNLOCKING_LEVEL:
      return {
        ...state,
        lastLevelUnlocked: Math.min(Math.max(state.lastLevelUnlocked, payload.level), TOTAL_LEVELS - 1),
      };

    default:
      return state;
  }
};

const sessionData = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case ACTIONS.INIT_SHADES_SESSION:
      return {
        ...initialState,
        levels: action.payload.levels,
      };

    case ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        screen: action.payload.screen,
      };

    case ACTIONS.LOCK_INTERATION:
      return {
        ...state,
        interactionLocked: true,
      };

    case ACTIONS.UNLOCK_INTERATION:
      return {
        ...state,
        interactionLocked: false,
      };

    case ACTIONS.START_NEW_ROUND:
      return {
        ...state,
        currentRound: reducers.currentRound(state.currentRound, action, state.levels),
      };

    case ACTIONS.ADVANCE_QUESTION:
      return {
        ...state,
        currentRound: reducers.currentRound(state.currentRound, action, state.levels),
      };

    default:
      return {
        ...state,
        currentRound: reducers.currentRound(state.currentRound, action),
        gameProgress: reducers.gameProgress(state.gameProgress, action),
      };
  }
};

const makeContentWithShuffledSet = (
  levelsDictionary,
  levelIndex,
  questionIndex,
) => {
  const content = levelsDictionary[levelIndex][questionIndex];
  return {
    ...content,
    shuffledSet: helperFunctions.makeShuffledArray(content.wordsData),
  };
};

const makeShuffledArray = originalArray => {
  let shuffledArray = [...originalArray];
  let stillTheSame = true;
  do {
    shuffledArray = shuffleArray(shuffledArray);
    for (let i = 0; i < shuffledArray.length; i++) {
      if (shuffledArray[i].word !== originalArray[i].word) {
        stillTheSame = false;
        break;
      }
    }
  } while (stillTheSame);

  return shuffledArray.reverse();
};

const helperFunctions = {
  makeContentWithShuffledSet,
  makeShuffledArray,
};

const reducers = {
  gameProgress,
  currentRound,
};

export { helperFunctions as _helperFunctions };

export { reducers as _reducers };

export default sessionData;
